<template>
  <a class="jobs-item-card-main" :class="[border ? 'border' : '', origin]" :href="`/jobs/${data.token}.html`"
     target="_blank" :style="{width}"
     :data-growing-title="'recommend-'+ (data.recommend_source || 0) + '-' + (data.recommend_type || 0)"
     data-gio-imp-track="recommend"
     :data-gio-track-type="(data.recommend_source || 0) + '-' + (data.recommend_type || 0)">
    <div class="jd-title">
      <div class="title text-overflow">{{ data.job_post }}</div>
      <div class="money">
        {{ (data.annual_month_salary && data.annual_month_salary > 12) ? `${data.display_salary} · ${data.annual_month_salary}薪` : data.display_salary }}
      </div>
    </div>
    <div class="tag">
      <div class="tag-menu">{{ (data.city_names && data.city_names[0]) || '全国' }}</div>
      <div class="tag-menu" v-if="data.job_nature === '校招'">{{ data.job_nature }}</div>
      <div class="tag-menu" v-if="data.job_nature === '全职'">
        {{ !data.display_experience || data.display_experience === '不限' ? '经验不限' : (data.display_experience === '1年以下' ? '1年以内' : data.display_experience) }}
      </div>
      <div class="tag-menu" v-if="data.job_nature === '校招'">{{ data.graduate_times | formatGraduationYear }}</div>
      <div class="tag-menu">{{ !data.degree_name || data.degree_name === '不限' ? '学历不限' : data.degree_name }}</div>
      <div class="tag-menu" v-if="data.intern_frequency && data.job_nature === '实习'">
        {{ `${data.intern_frequency}天/周` }}
      </div>
      <div class="tag-menu" v-if="data.intern_duration && data.job_nature === '实习'">{{ data.intern_duration }}</div>
      <div class="tag-menu" v-for="(tagItem, tagIndex) in (data.job_tags || [])" :key="tagIndex">{{ tagItem }}</div>
    </div>
    <div class="company">
      <div class="left">
        <div class="company-picture">
          <img :src="data.company_logo" alt="">
        </div>
        <span class="company-name">{{ data.company_nick_name || data.company_name }}</span>
      </div>
      <div class="company-info">
        <span class="company-industry">{{ data.company_industry }}</span>
        <span class="company-scale">{{ data.company_scale }}</span>
      </div>
    </div>
    <!-- <div class="jd-tag" v-if="data.origin_source === 'jd'">直投</div> -->


    <!-- data.recommend_source === 1 :   根据求职意向 推荐的职位 -->
    <!-- data.recommend_source === 2 :   根据简历分数 推荐的职位 -->
    <!-- 分数 < 5 显示求职意向 -->
    <div class="job-desc" v-if="show && data.recommend_source && data.match_score > 50">
      <p class="job-desc-text">
        <img class="icon"
             src="https://files.wondercv.com/cvs-job-pc/%E7%AE%80%E5%8E%86%E6%8E%A8%E8%8D%90%E6%A0%87%E7%AD%BE.png"
             alt="">
        <span class="text">该职位与您的简历匹配度为 {{ data.match_score }}% <i class="tooltip iconfont iconwenti1"><span
          class="dialog">{{ tooltipText }}</span></i></span>
      </p>
    </div>
    <div class="job-desc" v-else-if="show">
      <!-- 前端展示样式同步，增加的默认推荐原因 -->
      <p class="job-desc-text">
        <img class="icon"
             src="https://files.wondercv.com/cvs-job-pc/%E7%AE%80%E5%8E%86%E6%8E%A8%E8%8D%90%E6%A0%87%E7%AD%BE.png"
             alt="">
        <span class="text">该职位根据简历中的过往经历推荐</span>
      </p>
    </div>
  </a>
</template>
<script>
import {mapState} from 'vuex';

export default {
  name: 'JobsCard',
  data() {
    return {
      tooltipText: '匹配度范围为0-100%，是由平台大数据对职位类型/专业技能/竞争优势等多维度综合分析得出的预测值，简历越详细匹配会越准确。'
    }
  },
  props: {
    origin: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: '388px'
    },
    border: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('me', ['personInfo']),
    intentionText() {
      if (!this.data.expect_job_title) return ''
      // level3 中数组只有一个值，则为精确推荐，则展示level3中的值
      // 如果 level3 中值大于1，则随机展示 level1 中的值
      let {level1_names, level2_names, level3_names} = this.data.expect_job_title
      if (level3_names && level3_names.length) {
        return level3_names[0]
      } else if (level2_names && level2_names.length) {
        return level2_names[0]
      } else if (level1_names && level1_names.length) {
        return level1_names[0]
      } else {
        return ''
      }
    }
  },
  filters: {
    formatGraduationYear(yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('/') + '届'
    }
  }
}
</script>
<style lang="scss" scoped>
.jobs-item-card-main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 390px;
  height: 131px;
  background: #fff;
  flex: none;
  box-sizing: border-box;
  padding-top: 16px;
  position: relative;
   overflow: hidden;
  border-radius: 12px;
  transition: all .3s linear;

  &.border {
    border: 1px solid #ECECEC;
  }

  * {
    box-sizing: border-box;
  }

  &:hover {
    transform: translate(-2px, -2px);
    box-shadow: 0px 2px 28px 0px rgba(10, 44, 156, 0.1);
    border-color: #fff;

    .jd-title .title {
      color: #FF6644;
    }

    .job-desc {
      width: 373px !important;
      left: -25px !important;
      bottom: -1px !important;
    }
  }

  .jd-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 18px;
    padding: 0 16px;
    line-height: 18px;

    .title {
      font-family: PingFangSC-Medium, PingFang SC;
      max-width: 210px;
      font-size: 18px;
      color: #000;
      font-weight: 600;
    }

    .money {
      max-width: 120px;
      font-size: 16px;
      color: #FF6644;
      font-weight: 500;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .tag {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 12px;
    height: 24px;
    padding: 0 16px;
    overflow: hidden;

    .tag-menu {
      height: 21px;
      font-size: 12px;
      line-height: 21px;
      border-radius: 4px;
      margin-top: 2px;
      background: #F2F4F7;
      padding: 0 10px;
      margin-right: 6px;
    }
  }

  .company {
    width: 100%;
    height: 44px;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    background: linear-gradient(90deg, #FFF7F5 0%, #FFFFFF 100%);

    .left {
      display: flex;
      align-items: center;
      gap: 8px;
      .company-name {
        color: #1D2129;
        max-width: 140px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .company-picture {
      // width: 36px;
      // height: 36px;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #F9F9F9;

      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .company-info {
      //width: 295px;
      margin-left: 9px;
      line-height: 14px;
      font-size: 14px;
      color: #1D2129;

      & > span {
        position: relative;
        color: #606060;
        font-size: 14px;
        padding-right: 6px;
        margin-right: 6px;

        &::after {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          content: "";
          width: 1px;
          height: 9px;
          background: #CFCFCF;
        }

        &:last-of-type {
          padding-right: 0;
          margin-right: 0;
        }

        &:last-of-type::after {
          display: none;
        }
      }

      & > div {
        width: 100%;
        height: 14px;
      }

      .company-tag {
        font-weight: 400;
        color: #9C9C9C;
        margin-top: 8px;

        .l:last-child {
          display: none;
        }
      }

      .company-desc {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
      }
    }
  }

  .jd-tag {
    width: 70px;
    height: 18px;
    background: rgba(65, 131, 255, .05);
    color: rgba(65, 131, 255, 1);
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    position: absolute;
    top: 6px;
    left: -20px;
    z-index: 5;
    transform-origin: 50% 50%;
    transform: rotate(-45deg);
  }

  .job-desc {
    position: relative;
    left: -24px;
    width: 371px;

    background: #F9F9F9;
    margin-top: 16px;
    padding: 12px 24px;
    border-radius: 0 0 6px 6px;

    .job-desc-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 14px;

      > .icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }

      .tooltip {
        position: relative;
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-left: 2px;

        .dialog {
          width: 404px;
          padding: 10px;
          display: none;
          position: absolute;
          text-align: justify;
          bottom: -670%;
          left: -500%;
          transform: translateX(-50%);
          color: #fff;
          font-size: 14px;
          line-height: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          border-radius: 4px;
          background-color: #505667;
          z-index: 100;

          &::after {
            content: "";
            position: absolute;
            left: 69.5%;
            top: -7%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
            border-bottom: 7px solid #505667;
          }
        }

        &:hover {
          color: #505667;

          .dialog {
            display: block;
          }
        }
      }
    }
  }
}

.jobs-item-card-main.cvs {
  margin-bottom: 20px;
  border-radius: 8px;
  //padding: 20px;
  transition: all 0.15s;

  &:hover {
    transform: translateY(-5px);

    .job-desc {
      width: auto !important;
      left: 0 !important;
      bottom: 0 !important;
    }
  }

  .tag {
    margin-top: 12px;

    .tag-menu {
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      color: rgba($color: #000, $alpha: .6);
      border-radius: 4px;
    }
  }

  .company {
    margin-top: 12px;

    .company-picture {
      width: 24px;
      height: 24px;
    }

    .company-info {
      margin-left: 8px;

      span {
        color: #000;
      }
    }
  }

  .jd-title {
    height: 22px;

    .title {
      font-size: 16px;
      line-height: 18px;
      color: #000;
    }
  }

  .job-desc {
    margin-top: 12px;
    left: 0;
    width: auto;
    padding: 10px 12px;
    border-radius: 8px;

    .text {
      color: rgba($color: #000, $alpha: .6);
      font-size: 12px;
    }
  }
}

.margin-48 {
  margin-bottom: 48px;
}

.vline {
  display: inline-block;
  width: 1px;
  height: 9px;
  background: #CFCFCF;
  margin: 0 6px;
}

</style>
